import React from 'react'

import CollapsibleContent from '@/components/misc/CollapsibleContent'
import { ServiceFeeDetail } from '@/components/misc/ServiceFeesTable/ServiceFeesTableRows'
import { useIsPdf } from '@/hooks/useIsPdf'

interface Props {
  serviceFee: ServiceFeeDetail
}

const ServiceFeePassBackNotes: React.FC<Props> = ({ serviceFee }) => {
  const isPdf = useIsPdf()

  const { passBackFee, passBackFeeNotes } = serviceFee

  if (!passBackFee) {
    return '-'
  }

  const content = passBackFeeNotes ? `Yes. ${passBackFeeNotes}` : `Yes`

  return isPdf ? (
    content
  ) : (
    <CollapsibleContent content={content} collapseThreshold={100} />
  )
}

export default ServiceFeePassBackNotes
